import { useRef } from "react";
import isEqual from "lodash/isEqual";
function useMemoized(factory, deps) {
    const ref = useRef();
    let areEqual = true;
    for(let i = 0; i < deps.length; i++)if (ref.current?.deps[i] !== deps[i]) {
        areEqual = false;
        break;
    }
    if (void 0 === ref.current || false === areEqual) ref.current = {
        value: factory(),
        deps: deps
    };
    return ref.current.value;
}
function useDeepMemo(factory, deps) {
    const ref = useRef();
    if (void 0 === ref.current || false === isEqual(deps, ref.current.deps)) ref.current = {
        value: factory(),
        deps
    };
    return ref.current.value;
}
export { useDeepMemo, useMemoized };

//# sourceMappingURL=memo.js.map